import type { ChartMargins, ChartOffsets, ChartStyles } from './types'

export const CHART_MARGINS: ChartMargins = {
  left: 13,
  right: 4,
  bottom: 8,
  top: 0,
} as const

export const CHART_OFFSETS: ChartOffsets = {
  // Responsive function that calculates offsets dynamically for any height
  getHorizontalOffsets: (height: number) => {
    const numberOfLines = 5 // Current number of grid lines
    const topMargin = 20 // First line is always at 20px from top

    // Calculate the bottom position based on chart height
    const bottomPosition = height - 59

    const usableHeight = bottomPosition - topMargin
    const segment = usableHeight / (numberOfLines - 1)

    // Generate evenly distributed offsets
    return Array.from({ length: numberOfLines }, (_, index) => {
      return Math.round(topMargin + segment * index)
    })
  },
} as const

export const CHART_STYLES: ChartStyles = {
  fontSize: {
    axis: 12,
    tooltip: 14,
  },
  padding: {
    xAxis: {
      left: 54,
      right: 34,
    },
    yAxis: {
      top: 20,
      bottom: 20,
    },
  },
  animation: {
    duration: {
      drawLine: 1300,
      morphLine: 660,
      tooltip: 50,
    },
  },
} as const
